import React from 'react';

const StageSwitcherItem = (props) => {
    return <li className='stage' onClick={(e) => { e.stopPropagation(); props.onStageClick(props.id) }}>
        { props.title }
        <span className={'checkbox' + (props.checked ? ' checked' : '')} />
    </li>;
};

export default StageSwitcherItem;